import { render } from "./EnterprisesTable.vue?vue&type=template&id=4a5a07d2"
import script from "./EnterprisesTable.vue?vue&type=script&lang=js"
export * from "./EnterprisesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__